import React from "react";
import Button from "../subcomponents/Button";
import Title from "../subcomponents/Title";

const Content = () => {
      return(
            <div className="content">
                  <Title />
                  <Button />
            </div>
      );
};

export default Content;